import Notify from 'klicknotify';
import types from './types';
import API from '../../../services/request/account';
import i18n from '../../../i18n';

const api = new API();
const actions = {};

const onSuccess = (dispatch, action) => {
  const notifyMessage = i18n.t('account.notify.success.'.concat(action));
  Notify.success({ message: notifyMessage, autoHide: true });
  dispatch('modal/close', '', { root: true });
};

const onError = (error) => {
  Notify.error({ message: error.response.data.message, autoHide: true });
};

actions.get = ({ commit }) => api.get()
  .then((response) => {
    commit(types.SET_LIST, response.data);
  });

actions.save = ({ dispatch }, account) => {
  if (account.type === 'aweber') {
    return dispatch('aweber/authorizeAweber', account, { root: true });
  }

  if (account.type === 'rdstation') {
    return dispatch('rdstation/authorizeRDStation', account, { root: true });
  }

  if (!account.id) return dispatch('create', account);

  return dispatch('update', account);
};

actions.create = ({ commit, dispatch }, account) => api.post('', account)
  .then((response) => {
    commit(types.ADD_TO_LIST, response.data);
    onSuccess(dispatch, 'create');
  })
  .catch(onError);

actions.update = ({ commit, dispatch }, account) => api.put(account.id, account)
  .then((response) => {
    commit(types.EDIT_ITEM, response.data);
    onSuccess(dispatch, 'update');
  })
  .catch(onError);

actions.delete = ({ commit, dispatch }, id) => api.delete(id)
  .then(() => {
    commit(types.REMOVE_ITEM, id);
    onSuccess(dispatch, 'delete');
  })
  .catch(onError);

actions.setName = ({ commit }, name) => {
  commit(types.SET_EMAIL_SERVICE_NAME, name);
};

actions.setType = ({ commit }, type) => {
  commit(types.SET_EMAIL_SERVICE_TYPE, type);
};

actions.setConfig = ({ commit }, config) => {
  commit(types.SET_EMAIL_SERVICE_CONFIG, config);
};

actions.setActive = ({ commit }, account) => {
  commit(types.SET_ACTIVE, account);
};

actions.resetActive = ({ commit }) => {
  commit(types.RESET_ACTIVE);
};

export default actions;



// WEBPACK FOOTER //
// ./src/screens/Account/store/actions.js